"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const striptags_1 = __importDefault(require("striptags"));
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const translation_1 = require("../../../common/js/helper/translation");
const Paths_1 = require("../../constants/Paths");
const MassivePropertyGroup_1 = __importDefault(require("../../enums/MassivePropertyGroup"));
const media_1 = require("../../helper/media");
const path_1 = require("../../helper/path");
const product_1 = require("../../helper/product");
const ShopwareCategories_1 = __importDefault(require("../../stores/ShopwareCategories"));
const ShopwareContext_1 = __importDefault(require("../../stores/ShopwareContext"));
const ShopwareProducts_1 = __importDefault(require("../../stores/ShopwareProducts"));
class ShopHomePage extends react_1.default.Component {
    contextReactionDisposer;
    products = [];
    cachedProducts = [];
    title;
    description;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            isLoading: mobx_1.computed,
            cachedProducts: mobx_1.observable,
            products: mobx_1.observable,
            loadProducts: mobx_1.action,
            title: mobx_1.observable,
            description: mobx_1.observable,
        });
    }
    get isLoading() {
        return ShopwareContext_1.default.isLoading;
    }
    componentDidMount() {
        this.contextReactionDisposer = (0, mobx_1.reaction)(() => ShopwareContext_1.default.currentShopHomePageId, () => {
            ShopwareCategories_1.default.initialize().then(() => {
                const categoryID = (0, product_1.getProductSalesChannelId)();
                if (categoryID) {
                    this.loadProducts(categoryID);
                    this.loadText(categoryID);
                }
            });
        }, { fireImmediately: true });
    }
    loadProducts(categoryId) {
        const salesChannel = (0, product_1.getSalesChannelCustomFieldTitle)();
        ShopwareProducts_1.default.loadProductsForCategory(categoryId).then((0, mobx_1.action)((products) => {
            this.products =
                products?.sort((a, b) => {
                    const bValue = Number(b?.translated?.customFields?.[salesChannel] ?? Infinity);
                    const aValue = Number(a?.translated?.customFields?.[salesChannel] ?? Infinity);
                    return aValue - bValue;
                }) ?? [];
        }));
    }
    componentWillUnmount() {
        this.contextReactionDisposer?.();
    }
    loadText(categoryId) {
        this.title = ShopwareCategories_1.default.getCategory(categoryId)?.translated.name;
        this.description = ShopwareCategories_1.default.getCategory(categoryId)?.translated.description;
    }
    render() {
        if (this.isLoading) {
            return (react_1.default.createElement("section", { className: "container" },
                react_1.default.createElement(LoadingSpinner_1.default, { center: true })));
        }
        return (react_1.default.createElement("section", { className: "container" },
            react_1.default.createElement("div", { className: "znd-block" },
                react_1.default.createElement("div", { className: "znd-block__headline" },
                    react_1.default.createElement("div", { className: "znd-block__text" },
                        react_1.default.createElement("div", { className: "mb-3" },
                            react_1.default.createElement("h4", null, this.title)),
                        this.description ? (react_1.default.createElement("div", { className: "mb-3", dangerouslySetInnerHTML: {
                                __html: this.description,
                            } })) : null))),
            this.products.length > 0 ? (react_1.default.createElement("div", { className: "znd-block__grid" }, this.products.map((product) => this.renderItem(product)))) : null));
    }
    productMedia(product) {
        if (!product) {
            return [];
        }
        const { cover, media } = product;
        if (!media) {
            return [];
        }
        return media
            .filter((productMedia) => productMedia.mediaId !== cover?.mediaId)
            .map((productMedia) => productMedia.media)
            .filter((item) => !!item);
    }
    renderItem(product) {
        const [productImage = product?.cover?.media] = this.productMedia(product);
        const property = this.propertyValue(product.extensions?.massiveProperties ? product.extensions?.massiveProperties : []);
        return (react_1.default.createElement("div", { className: "znd-shop-page__product", key: product.id },
            productImage ? (react_1.default.createElement("div", { className: "znd-shop-page__product__img" },
                react_1.default.createElement("img", { ...(0, media_1.imageSourceFromMedia)(productImage), alt: productImage.alt }))) : null,
            react_1.default.createElement("div", { className: "znd-shop-page__product__content" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h5", { className: "znd-shop-page__product__content-title" }, product.translated?.name),
                    react_1.default.createElement("p", { className: "znd-shop-page__product__content-description", dangerouslySetInnerHTML: {
                            __html: (0, striptags_1.default)(product.translated?.description ?? '') +
                                (property ? '<br/>' + property : ''),
                        } })),
                react_1.default.createElement(react_router_dom_1.Link, { to: (0, path_1.localePath)(`${Paths_1.PATH_SHOP}/product/${product?.productNumber}`) },
                    react_1.default.createElement(Button_1.default, { className: "btn-primary btn d-flex align-items-center --btn-full-width", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('user.profile.orders.view_details') })))));
    }
    propertyValue(properties) {
        for (const property of properties) {
            if (MassivePropertyGroup_1.default.propertyExternalId ===
                property?.group?.extensions?.massivePropertyGroup?.externalId) {
                return property.translated?.name ?? '';
            }
        }
        return '';
    }
}
__decorate([
    bind_decorator_1.default
], ShopHomePage.prototype, "renderItem", null);
exports.default = (0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)(ShopHomePage));
